import React from 'react';

const AboutSection = ({ onJoinCommunity }) => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <p>
              Ooowap is the premier platform for purse enthusiasts to trade their favorite bags.
              We believe that style should be shared, and every purse has a story worth telling.
            </p>
            <p>
              Our community connects bag lovers worldwide, allowing you to experience different styles
              and cultures through temporary trades. Whether you're looking to try a new look or share
              your favorite bag with someone who will appreciate it, Ooowap makes it easy and safe.
            </p>
            <button className="btn btn-primary" onClick={onJoinCommunity}>Join Community</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;